import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Content = styled.div(
  ({theme}) => css`
    padding: 16px 12px;
    display: grid;
    grid-template-rows: auto auto auto;
    grid-template-columns: auto;
    gap: 12px;

    ${theme.respondTo(
      'md',
      css`
        padding: 12px;
      `
    )}

    ${theme.respondTo(
      'lg',
      css`
        grid-template-rows: auto;
        grid-template-columns: 1fr auto minmax(225px, min-content);
      `
    )}
  `
);
